import React from 'react'
import Icon from '../Icon/Icon.tsx'
import Typography from '../Typography/Typography.tsx'

type Props = {
    icon?: React.ReactNode
    classes: Record<string, string>
    disabled: boolean
    selectMultiple: boolean
    selectedValue: any
    options: Array<{ value?: any; text?: React.ReactNode }>
    placeholder?: string
    title: string
}

/**
 *
 */
const SearchableSelectTrigger = ({
    icon,
    classes,
    disabled,
    selectMultiple,
    selectedValue,
    options,
    placeholder,
    title
}: Props): JSX.Element => {
    const selectedText = !selectMultiple
        ? options.find((x) => x.value === selectedValue)?.text || title
        : (
            <Typography variant='body2'>
                {placeholder || (
                    Array.isArray(selectedValue) && selectedValue.length > 0
                        ? `${selectedValue.length} selected`
                        : title
                )}
            </Typography>
        )

    return (
        <>
            {icon && !selectMultiple && (
                <div className={classes.icon}>
                    {typeof icon === 'string'
                        ? <Icon name={icon} color='primary' size={24} />
                        : icon}
                </div>
            )}
            <div className={`${classes.select} select-value`}>
                {selectedText}
            </div>
        </>
    )
}

export default SearchableSelectTrigger
